import { render, staticRenderFns } from "./InterviewsList.vue?vue&type=template&id=8715fd1e&"
import script from "./InterviewsList.vue?vue&type=script&lang=js&"
export * from "./InterviewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports